'use client';

import { useState } from 'react';

import {
    Button,
    ButtonList,
    ButtonVariant,
    ModalBody,
    ModalFooter,
    RadioTile,
    RadioTiles,
    Spacer,
    SpacerSize,
    Text,
    TypographyAlign,
} from '@bytel/trilogy-react';

import { PLAY } from '@constants/provider';

import { FaiUpsellModalProps } from './fai-upsell-modal.props';

export function DowngradeUltymPlayUpsellModal({
    clickedOffer,
    upsellOffer,
    onAddOffer,
}: Readonly<FaiUpsellModalProps>) {
    const [choice, setChoice] = useState<PLAY>(PLAY._3P);

    return (
        <>
            <ModalBody>
                <Text typo={TypographyAlign.TEXT_LEFT}>
                    Vous n&apos;avez pas forcément besoin de vous encombrer d&apos;un décodeur TV.
                </Text>
                <Spacer size={SpacerSize.SIX} />
                <RadioTiles>
                    <RadioTile
                        name='checkbox1'
                        id='choiceYes'
                        label="Le décodeur TV + l'appli B.tv+"
                        description='180 chaînes sur 2 écrans en simultané (inclus dans cette offre Bbox).'
                        value={PLAY._3P}
                        checked={choice === PLAY._3P}
                        onChange={() => setChoice(PLAY._3P)}
                        horizontal
                    />
                    <RadioTile
                        name='checkbox1'
                        id='choiceNo'
                        label="L'appli B.tv uniquement"
                        description='70 chaînes sur votre téléphone, tablette et PC.'
                        value={PLAY._2P}
                        checked={choice === PLAY._2P}
                        onChange={() => setChoice(PLAY._2P)}
                        horizontal
                    />
                </RadioTiles>
            </ModalBody>
            <ModalFooter>
                <ButtonList>
                    <Button
                        variant={ButtonVariant.CONVERSION}
                        onClick={() => onAddOffer?.(choice === PLAY._3P ? clickedOffer : upsellOffer)}
                    >
                        Continuer
                    </Button>
                </ButtonList>
            </ModalFooter>
        </>
    );
}
